<ng-container *ngIf="auth.user.country_id==233">
  <div class="row mx-0">
    <div class="col-md-6 head-top">
      <div class="send-money ">

        <div class="sm-18 font-weight-bold color-blue pl-2 pb-3">How much will you send?</div>
        <div class="mb-2">
          <form #transactionForm="ngForm" (ngSubmit)="onFormSubmit(transactionForm)">
            <div class="div-block-13 bg-white w-100">
              <input (keyup)="onAmountChange($event)" type="number" class="text-field w-input m-0 p-3 border-0" def="10"
                autofocus="true" maxlength="256" name="sending_amt" [(ngModel)]="source_amount" required=""
                [readonly]="sendMoneyService.isAcknowlodgingRequest">
              <div class="w-dropdown bg-alice radiusr-5">
                <div class="dropdown-toggle-2 w-dropdown-toggle p-3">
                  <div id="from-currency" class="div-block-11 mr-0">
                    <ng-container *ngIf="auth.user.currency">
                      <div class="selected-currency-code color-blue mr-1">{{auth.user.currency.toUpperCase()}}</div>
                      <img [src]="'assets/images/'+auth.user.currency.toLowerCase()+'.png'" loading="lazy"
                        alt="n2xpress - Money Transfer - US Dollar" class="image-7 m-0 flag-send-money">
                    </ng-container>
                  </div>
                </div>
              </div>

            </div>
            <div class="sm-10 text-danger" style="height:15px">
              <span *ngIf="setMinLimit()">Please send a minimum amount of $10
                {{auth.user.currency.toUpperCase()}}.</span>
              <span [innerHTML]="error_monthly_limit" class="position-absolute"></span>
            </div>
            <div class="rate-panel">
              <div class="div-block-15  more-height crossIcon"></div>
              <div class="div-block-16">
                <div class="div-block-18">
                  <span class="bg-alice rounded-circle symbol color-blue">x</span>
                  <div class="rate-figure">
                    <div id="currency-rate" class="text-block-12">{{conversionRate}}</div>
                  </div>
                  <div class="rate-currency">
                    <div id="exchange-currency" class="rate-currency-text">
                      {{sendMoneyService.receiver.currency.toUpperCase()}}</div>
                  </div>
                  <div class="rate-explainer">
                    <div class="explainer-text">Your exchange rate</div>
                  </div>
                </div>

                <div class="div-block-13-copy w-100 bg-white">
                  <span class="bg-alice rounded-circle symbol color-blue">=</span>
                  <input placeholder="Recipient gets" type="number" [(ngModel)]="convertedAmount" readonly required
                    style="background:none!important; border:none;" class="text-field w-input" maxlength="256"
                    name="send_amt">
                  <div class="w-dropdown bg-alice radiusr-5">
                    <div class="cxy-dropdown-toggle w-dropdown-toggle p-3">
                      <div id="to-currency" class="div-block-11 mr-0">
                        <div class="text-block-10 color-blue mr-1">{{sendMoneyService.receiver.currency.toUpperCase()}}
                        </div>
                        <img [src]="'assets/images/'+sendMoneyService.receiver.currency.toLowerCase()+'.png'"
                          loading="lazy" alt="n2xpress - Money Transfer - Indian Rupee"
                          class="image-7 m-0 flag-send-money">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="div-block-17">
                  <span class="bg-alice rounded-circle symbol color-blue">+</span>

                  <div>
                    <div class="fee-figure">{{transactionFees}}</div>
                  </div>
                  <div class="rate-currency">
                    <div class="rate-currency-text">USD</div>
                  </div>
                  <div class="fee-explainer-text">
                    <div class="explainer-text">Payment processing fee</div>
                  </div>
                </div>
                <div class="w-100">
                  <select (change)="onPaymentTypeChange($event.target.value)" class="select-payment w-100"
                    name="payment_method" ngModel required>
                    <option value="" hidden> -- Select Payment Method --</option>
                    <option [value]="item" *ngFor="let item of paymentTypes"> {{item}} </option>
                  </select>
                </div>
                <div class="w-100">
                  <select class="select-payment mt-3 w-100" name="funding_sources_id" [(ngModel)]="funding_source"
                    required>
                    <option value="" hidden> -- Select Funding Source --</option>
                    <option [value]="item.id" *ngFor="let item of resultFundingSources"> {{item.institution_name}}
                    </option>
                  </select>
                </div>
                <div class="div-block-17">
                  <span class="bg-alice rounded-circle symbol color-blue">+</span>

                  <div>
                    <div class="fee-figure">{{gatewayFee}}</div>
                  </div>
                  <div class="rate-currency">
                    <div class="rate-currency-text">USD</div>
                  </div>
                  <div class="fee-explainer-text">
                    <div class="explainer-text">Gateway fee</div>
                  </div>
                </div>
                <!-- Promocode Section -->
                <div class="mt-3">
                  <div class="card-header p-0 border-0" style="background: none;" role="tab" id="headingOne1">
                    <!-- <a data-toggle="collapse" data-parent="#accordionEx" href="#collapseOne2"
                  aria-expanded="true" aria-controls="collapseOne1" (click)="changeHeight()"> -->
                    <h5 class="mb-0">
                      <div class="row">
                        <div class="col-8 sm-14 color-blue mobile16">
                          Apply Promocode
                        </div>
                        <!-- <div class="col-4">
                        <i class="fas fa-angle-down rotate-icon float-left"></i>
                      </div> -->
                      </div>
                    </h5>
                    <!-- </a> -->
                  </div>
                </div>
                <!-- <div id="collapseOne2" class="collapse p-0" role="tabpanel" aria-labelledby="headingOne1"
            data-parent="#accordionEx"> -->
                <div class="card-body p-0">
                  <div class="row">
                    <div class="col-md-6">
                      <input type="text" class="form-control promocode-form p-0" placeholder="Enter Promocode"
                        [(ngModel)]="coupon_code" [ngModelOptions]="{standalone: true}" [readonly]="is_applied_coupon">
                    </div>
                    <div class="col-md-6">
                      <button class="btn btn-primary" (click)="addPromo($event)"
                        [disabled]="(!source_amount || !funding_source || is_applied_coupon)">
                        Apply
                      </button>
                    </div>
                  </div>
                </div>
                <!-- </div> -->
                <!-- Promocode Section End -->
                <div class="div-block-18">
                  <span class="bg-alice rounded-circle symbol color-blue">=</span>

                  <div class="rate-figure">
                    <div id="currency-rate" class="text-block-12">{{totalAmountDeducted}}</div>
                  </div>
                  <div class="rate-currency">
                    <div id="exchange-currency" class="rate-currency-text">USD</div>
                  </div>

                  <div class="rate-explainer">
                    <div class="secondary-text sm-10">Total you will be charged</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="my-5 d-flex justify-content-between address_field step3-btn">
              <button (click)="goBack()" type="button" class="btn transparent-btn primary-text back-btn">Back</button>
              <button type="submit"
                [disabled]="!transactionForm.valid || !+source_amount || setMinLimit() || maxLimitReached || maxUserLimit"
                class="btn w-100 primary-btn text-white">Next</button>
            </div>
          </form>
        </div>



      </div>
    </div>
  </div>
</ng-container>


<ng-container *ngIf="auth.user.country_id==39">
  <div class="row mx-0">
    <div class="col-md-6 head-top">
      <div class="send-money ">

        <div class="sm-18 font-weight-bold color-blue pl-2 pb-3">How much will you send?</div>
        <div class="mb-2">
          <form #caTRansactionForm="ngForm" (ngSubmit)="onCaFormSubmit(caTRansactionForm)">
            <div class="div-block-13 bg-white w-100">
              <input type="number" name="sending_amount" (keyup)="onAmountChange($event)"
                class="text-field w-input m-0 p-3 border-0" def="10" autofocus="true" maxlength="256" name="sending_amt"
                [(ngModel)]="source_amount" required [readonly]="sendMoneyService.isAcknowlodgingRequest">

              <div class="w-dropdown bg-alice radiusr-5">
                <div class="dropdown-toggle-2 w-dropdown-toggle p-3">
                  <div id="from-currency" class="div-block-11 mr-0">
                    <div class="selected-currency-code color-blue mr-1">{{auth.user.currency.toUpperCase()}}</div>
                    <img [src]="'assets/images/'+auth.user.currency.toLowerCase()+'.png'" loading="lazy"
                      alt="n2xpress - Money Transfer - Canadian Dollar" class="image-7  m-0" width="25" height="25">
                  </div>
                </div>
              </div>

            </div>
            <!-- <div class="sm-10 text-danger" >
            </div> -->
            <div class="sm-10 text-danger" style="height:15px">
              <span *ngIf="setMinLimit()">Please send a minimum amount of $10 CAD.</span>
              <span [innerHTML]="error_monthly_limit"></span>
            </div>
            <div class="rate-panel mb-5">
              <div class="side-line h-auto"></div>
              <div class="div-block-16">
                <div class="div-block-18-copy py-3">
                  <span class="bg-alice rounded-circle symbol color-blue">x</span>
                  <div class="rate-figure">
                    <div id="currency-rate" class="text-block-12">{{conversionRate}}</div>
                  </div>
                  <div class="rate-currency">
                    <div id="exchange-currency" class="rate-currency-text">
                      {{sendMoneyService.receiver?.currency.toUpperCase()}}</div>
                  </div>
                  <div class="rate-explainer">
                    <div class="explainer-text sm-12">Your exchange rate</div>
                  </div>
                </div>
                <div class="div-block-13-copy w-100 bg-white">
                  <span class="bg-alice rounded-circle symbol color-blue">=</span>
                  <input type="number" [(ngModel)]="convertedAmount" readonly
                    style="background:none!important; border:none;" class="text-field w-input m-0" maxlength="256"
                    name="send_amt">
                  <div class="w-dropdown bg-alice radiusr-5">
                    <div class="dropdown-toggle-2 w-dropdown-toggle p-3">
                      <div id="to-currency" class="div-block-11 mr-0">
                        <div class="text-block-10 color-blue receiveCountry">
                          {{sendMoneyService.receiver.currency.toUpperCase()}}</div>
                        <img [src]="'assets/images/'+sendMoneyService.receiver.currency.toLowerCase()+'.png'"
                          loading="lazy" alt="n2xpress - Money Transfer - Indian Rupee"
                          class="image-7 receive-moneyImg m-0 flag-send-money"
                          [ngClass]="{'flag-circle':sendMoneyService.receiver.currency.toLowerCase()=='gbp'}">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="sm-10 text-danger" *ngIf="maxLimitReached">Maximum limit for currency exceeded.</div>
                <div class="div-block-17-copy pt-3">
                  <span class="bg-alice rounded-circle symbol color-blue">+</span>
                  <div>
                    <div class="fee-figure">{{transactionFees}}</div>
                  </div>
                  <div class="rate-currency">
                    <div class="rate-currency-text">CAD</div>
                  </div>
                  <div class="fee-explainer-text">
                    <div class="explainer-text">Payment processing fee</div>
                  </div>
                </div>

                <div (click)="onSelectCAPaymentMethod(item)"
                  class="absd select-payment mt-3 px-2 w-100 radius-5 border-blue d-flex align-items-center"
                  [ngClass]="{'active': item==sendMoneyService.selectedCAPaymentMethod}"
                  *ngFor="let item of sendMoneyService.caPaymentMethods">
                  <div class="text-block-10 text-left send-via-Interac sm-14 w-100 p-0 m-0">
                    <div class="row m-0 p-0">
                      <div
                        class="col-10 sm-10 color-blue gilroy-bold px-0 d-flex justify-content-between align-items-center">
                        {{item.description}} ({{ !item.gateway_fee_type ? ''+item.gateway_fee+' CAD' :
                        item.gateway_fee+' %'}})

                        <!-- <img *ngIf="" src="assets/images/b4.png" style="height:22px;width:22px" alt=""> -->
                        <!-- <img *ngIf="" src="assets/images/interac_logo.svg" style="height:22px;width:22px" alt="">
                          <img *ngIf="" src="assets/images/masterCard.png" style="height:22px;width:22px" alt="">
                          <img *ngIf="" src="assets/images/visa.jpg" style="height:22px;width:22px" alt=""> -->


                      </div>
                      <div class="col-2 p-0 text-right">
                        <!-- <img src="assets/images/b3.png" style="height:22px;width:22px" alt=""> -->
                        <img *ngFor="let image of item.image.split(',')" [src]="image" style="width:40px"
                          [alt]="item.description">

                      </div>
                      <!-- <div class="col-4 pl-1 pr-0 mt-2">+ $0.00 USD</div> -->
                    </div>
                  </div>
                </div>
                <!-- Promocode Section -->
                <div class="mt-3">
                  <div class="card-header p-0 border-0" style="background: none;" role="tab" id="headingOne1">
                    <!-- <a data-toggle="collapse" data-parent="#accordionEx" href="#collapseOne2"
                  aria-expanded="true" aria-controls="collapseOne1" (click)="changeHeight()"> -->
                    <h5 class="mb-0">
                      <div class="row">
                        <div class="col-8 sm-14 color-blue mobile16">
                          Apply promocode
                        </div>
                        <!-- <div class="col-4">
                        <i class="fas fa-angle-down rotate-icon float-left"></i>
                      </div> -->
                      </div>
                    </h5>
                    <!-- </a> -->
                  </div>
                </div>
                <!-- <div id="collapseOne2" class="collapse p-0" role="tabpanel" aria-labelledby="headingOne1"
            data-parent="#accordionEx"> -->
                <div class="card-body p-0">
                  <div class="row">
                    <div class="col-md-6">
                      <input type="text" class="form-control promocode-form p-0" placeholder="Enter Promocode"
                        [(ngModel)]="coupon_code" [ngModelOptions]="{standalone: true}" [readonly]="is_applied_coupon">
                    </div>
                    <div class="col-md-6">
                      <button class="btn btn-primary" (click)="addPromo($event)"
                        [disabled]="(!source_amount || !selectedCaPaymentMethod || is_applied_coupon)">
                        Apply
                      </button>
                    </div>
                  </div>
                </div>
                <!-- </div> -->
                <!-- Promocode Section End -->
                <div class="div-block-18-copy pt-3">
                  <span class="bg-alice rounded-circle symbol color-blue">=</span>
                  <div class="rate-figure">
                    <div id="currency-rate" class="text-block-12">{{totalAmountDeducted}}</div>
                  </div>
                  <div class="rate-currency">
                    <div id="exchange-currency" class="rate-currency-text">CAD</div>
                  </div>
                  <div class="rate-explainer">
                    <div class="explainer-text">Total you will be charged</div>
                  </div>
                </div>


                <div *ngIf="celoData.paymentSelectedoption.payment_gateways_id == 6"
                  [ngClass]="celoData.paymentSelectedoption.payment_gateways_id != 6  ? 'display_none': ''">
                  <div class="div-block-18-copy pt-3">
                    <span class="bg-alice rounded-circle symbol color-blue">=</span>
                    <div class="rate-figure">
                      <div id="celo-currency-rate" class="text-block-12">{{celoData.response.celo_value_plus_fee}}</div>
                    </div>
                    <div class="rate-explainer">
                      <div class="explainer-text">cUSD</div>
                    </div>
                  </div> <br>
                  <div>

                    <p>Please enter the wallet number from which you will initiate the transaction. 
                    If this address does not match the deposit transaction hash we will not be able to process the transaction.</p>

                    <input type="text" (keypress)="omit_special_char($event)" required [(ngModel)]="celoData.celoWalletNumber" name="celoWalletNumber"
                      class="form-control promocode-form p-0" placeholder="Celo wallet number Ex-12345">
                    <!-- <textarea placeholder="Celo wallet number&#13;&#10;Ex-12345"></textarea> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-4 d-flex justify-content-between">
              <button (click)="goBack()" type="button" class="btn transparent-btn primary-text w-50">Back</button>
              <button type="submit"
                [disabled]="!caTRansactionForm.valid || !sendMoneyService.selectedCAPaymentMethod || !+source_amount || setMinLimit() || maxLimitReached || maxUserLimit"
                class="btn px-5 primary-btn text-white w-50">Next</button>
            </div>
          </form>
        </div>



      </div>
    </div>
  </div>
</ng-container>